import PricePlanCalculatorSettings from 'client/components/core/Sidebar/components/Settings/entities/PricePlanCalculatorSettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import React from 'react'
import {
  AdditionalProps,
  createWebsiteEntityElement,
} from 'src/editor/pages/website-pricing/create-website-entity-element'

export default function createEntityElementForWebsitePricing(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.PricePlanCalculator:
      return (
        <PricePlanCalculatorSettings
          entity={entity as PricePlanCalculatorInterface}
          {...additionalProps}
        />
      )
    default:
      return createWebsiteEntityElement(entity, additionalProps)
  }
}
